import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Cursor Usage Events',
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'records',
                },
              },
              subqueries: {
                records: {
                  target: 'ent:!cursor_usage_events:!cursor_usage_event',
                },
              },
            },
          },
          query: {
            '`': {
              sort: {
                by: {
                  '@.': '!occurred_at',
                },
              },
              target: 'ent:!cursor_usage_events:!cursor_usage_event',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      model: {
                        '{}': {
                          value: {
                            '@.': '!model',
                          },
                        },
                      },
                      client: {
                        '{}': {
                          value: {
                            '@.': '!client',
                          },
                        },
                      },
                      jiraKey: {
                        '{}': {
                          value: {
                            '@.': '!jira_key',
                          },
                        },
                      },
                      project: {
                        '{}': {
                          value: {
                            '@.': '!project',
                          },
                        },
                      },
                      repoUrl: {
                        '{}': {
                          value: {
                            '@.': '!repo_url',
                          },
                        },
                      },
                      artifacts: {
                        '{}': {
                          value: {
                            '@.': '!artifacts',
                          },
                        },
                      },
                      commitSha: {
                        '{}': {
                          value: {
                            '@.': '!commit_sha',
                          },
                        },
                      },
                      netRoiUsd: {
                        '{}': {
                          value: {
                            '@.': '!net_roi_usd',
                          },
                        },
                      },
                      userEmail: {
                        '{}': {
                          value: {
                            '@.': '!user_email',
                          },
                        },
                      },
                      confidence: {
                        '{}': {
                          value: {
                            '@.': '!confidence',
                          },
                        },
                      },
                      costSource: {
                        '{}': {
                          value: {
                            '@.': '!cost_source',
                          },
                        },
                      },
                      linesAdded: {
                        '{}': {
                          value: {
                            '@.': '!lines_added',
                          },
                        },
                      },
                      occurredAt: {
                        '{}': {
                          value: {
                            '@.': '!occurred_at',
                          },
                        },
                      },
                      inputTokens: {
                        '{}': {
                          value: {
                            '@.': '!input_tokens',
                          },
                        },
                      },
                      requestType: {
                        '{}': {
                          value: {
                            '@.': '!request_type',
                          },
                        },
                      },
                      tokenSource: {
                        '{}': {
                          value: {
                            '@.': '!token_source',
                          },
                        },
                      },
                      totalTokens: {
                        '{}': {
                          value: {
                            '@.': '!total_tokens',
                          },
                        },
                      },
                      generationId: {
                        '{}': {
                          value: {
                            '@.': '!generation_id',
                          },
                        },
                      },
                      outputTokens: {
                        '{}': {
                          value: {
                            '@.': '!output_tokens',
                          },
                        },
                      },
                      conversationId: {
                        '{}': {
                          value: {
                            '@.': '!conversation_id',
                          },
                        },
                      },
                      requestSummary: {
                        '{}': {
                          value: {
                            '@.': '!request_summary',
                          },
                        },
                      },
                      cacheReadTokens: {
                        '{}': {
                          value: {
                            '@.': '!cache_read_tokens',
                          },
                        },
                      },
                      externalEventId: {
                        '{}': {
                          value: {
                            '@.': '!external_event_id',
                          },
                        },
                      },
                      cacheWriteTokens: {
                        '{}': {
                          value: {
                            '@.': '!cache_write_tokens',
                          },
                        },
                      },
                      estimatedCostUsd: {
                        '{}': {
                          value: {
                            '@.': '!est_cost_usd',
                          },
                        },
                      },
                      actualCursorMinutes: {
                        '{}': {
                          value: {
                            '@.': '!actual_cursor_minutes',
                          },
                        },
                      },
                      estimatedHoursSaved: {
                        '{}': {
                          value: {
                            '@.': '!est_hours_saved',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'externalEventId',
                  direct: {
                    '{}': {
                      name: 'External Event ID',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'occurredAt',
                  direct: {
                    '{}': {
                      name: 'Occurred At',
                      type: 'DATE',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'userEmail',
                  direct: {
                    '{}': {
                      name: 'User Email',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'client',
                  direct: {
                    '{}': {
                      name: 'Client',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'repoUrl',
                  direct: {
                    '{}': {
                      name: 'Repo URL',
                      type: 'URL',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'conversationId',
                  direct: {
                    '{}': {
                      name: 'Conversation ID',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'jiraKey',
                  direct: {
                    '{}': {
                      name: 'Jira Key',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'requestSummary',
                  direct: {
                    '{}': {
                      name: 'Request Summary',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'requestType',
                  direct: {
                    '{}': {
                      name: 'Request Type',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'artifacts',
                  direct: {
                    '{}': {
                      name: 'Artifacts',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'linesAdded',
                  direct: {
                    '{}': {
                      name: 'Lines Added',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'estimatedHoursSaved',
                  direct: {
                    '{}': {
                      name: 'Estimated Hours Saved',
                      type: 'DECIMAL',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'confidence',
                  direct: {
                    '{}': {
                      name: 'Confidence',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'model',
                  direct: {
                    '{}': {
                      name: 'Model',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'generationId',
                  direct: {
                    '{}': {
                      name: 'Generation ID',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'inputTokens',
                  direct: {
                    '{}': {
                      name: 'Input Tokens',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'outputTokens',
                  direct: {
                    '{}': {
                      name: 'Output Tokens',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'cacheReadTokens',
                  direct: {
                    '{}': {
                      name: 'Cache Read Tokens',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'cacheWriteTokens',
                  direct: {
                    '{}': {
                      name: 'Cache Write Tokens',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'totalTokens',
                  direct: {
                    '{}': {
                      name: 'Total Tokens',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'tokenSource',
                  direct: {
                    '{}': {
                      name: 'Token Source',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'estimatedCostUsd',
                  direct: {
                    '{}': {
                      name: 'Estimated Cost (USD)',
                      type: 'CURRENCY',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'costSource',
                  direct: {
                    '{}': {
                      name: 'Cost Source',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'netRoiUsd',
                  direct: {
                    '{}': {
                      name: 'Net ROI (USD)',
                      type: 'CURRENCY',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'actualCursorMinutes',
                  direct: {
                    '{}': {
                      name: 'Actual Cursor Minutes',
                      type: 'DECIMAL',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'commitSha',
                  direct: {
                    '{}': {
                      name: 'Commit SHA',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'project',
                  direct: {
                    '{}': {
                      name: 'Project',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
        },
      },
    },
  },
}
